import React from 'react'
import { Divider,List, ListItem, ListItemText, ListSubheader, ListItemIcon,Box, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import {useTheme} from '@mui/material/styles';
import { useDispatch } from 'react-redux';

import useStyles from "./styles";
import { useGetGenresQuery } from '../../services/TMDB';
import genreIcons from '../../assets/genres';
import { selectGenreOrCategory } from '../../features/currentGenreOrCategory';


//* Dummy Data for Categories
const categories = [
  { label: 'Popular', value: 'popular' },
  { label: 'Top Rated', value: 'top_rated' },
  { label: 'Upcoming', value: 'upcoming' },
];

//* Logo URLS
const redLogo = 'https://fontmeme.com/permalink/210930/8531c658a743debe1e1aa1a2fc82006e.png';
const blueLogo = 'https://fontmeme.com/permalink/210930/6854ae5c7f76597cf8680e48a2c8a50a.png';

const Sidebar = ({setMobileOpen}) => {
  const theme = useTheme(); //* tells theme of screen
  const { classes } = useStyles(); //*styles class

  const { data, error, isFetching } = useGetGenresQuery();

  const dispatch = useDispatch();

  // ! Error Handling
  if (error) {
    return 'An Error Occurred.';
  }


  return (
  <>
    <Link to="/" className={classes.imageLink}>
    {/* Sidebar Logo */}
        <img 
            className={classes.image}
            src={theme.palette.mode ==='light' ? redLogo: blueLogo}
            alt='Filmpire Logo'
        />
    </Link>
      <Divider />
      <List>
        {/* Categories */}
        <ListSubheader>Categories</ListSubheader>
        {categories.map(({ label, value }) => (
          <Link key={value} className={classes.links} to='/'>
            <ListItem onClick={() => dispatch(selectGenreOrCategory(value))} button>
              <ListItemIcon>
                <img src={genreIcons[label.toLowerCase()]} alt='category-logo' className={classes.genreImage} height={30} />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          </Link>

        ))}
      </List>
      <Divider />

      {/* Movie Genres */}
      <List>
        <ListSubheader>Genres</ListSubheader>
        {isFetching ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : data.genres.map(({ name, id }) => (
          <Link key={name} className={classes.links} to='/'>
            <ListItem onClick={() => dispatch(selectGenreOrCategory(id))} button>
              <ListItemIcon>
                <img src={genreIcons[name.toLowerCase()]} alt='category-logo' className={classes.genreImage} height={30} />
              </ListItemIcon>
              <ListItemText primary={name} />
            </ListItem>
          </Link>

        ))}
      </List>
  </>
    )
}

export default Sidebar